import _ from 'lodash';
import { Space, Table, Card, Result, Row, Col, Descriptions, Flex, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../AppConfig';
import PositionChange from '../components/PositionChange';
import PointsChange from '../components/PointsChange';
import { motion } from 'motion/react';
import { useTranslation } from 'react-i18next';

// Ranking page component
function Ranking(props) {
    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [items, setItems] = useState([]);
    const [width, setWidth] = useState(window.innerWidth);
    const { t } = useTranslation();

    // console.warn('width attuale: ', width);
    
    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }

    function checkQualified(player) {
      if (player && player.currentTppPoints >= 300) {
        return 'card-success';
      }
      return '';
    }

    const columns = [
        {
            title: t('columns.position'),
            width: '8%',
            dataIndex: 'lpiRanking',
            sorter: (a, b) => { 
                // console.warn(a,b);
                if (a.lpiRanking === b.lpiRanking) {
                  return 0;
                }
                
                if (a.lpiRanking < b.lpiRanking) {
                  return 1;
                } else {
                  return -1;
                }
              },
        },
        {
            title: t('columns.positionChange'),
            dataIndex: 'lpiPreviousRanking',
            width: '8%',
            render: (_,record) => <PositionChange player={record} />,
            sorter: (a, b) => { 
                if ((a.lpiRanking - a.lpiPreviousRanking) === (b.lpiRanking - b.lpiPreviousRanking)) {
                  return 0;
                }
                
                if ((a.lpiRanking - a.lpiPreviousRanking) < (b.lpiRanking - b.lpiPreviousRanking)) {
                  return 1;
                } else {
                  return -1;
                }
              },
        },
        {
            title: t('columns.player'),
            dataIndex: 'firstName',
            key: 'name', 
            render: (_,record) => <Space><Link to={'/players/'+record.id+'/'}>{record.firstName} {record.lastName}</Link></Space>
        },
        {
            title: t('columns.lpiPoints'),
            width: '8%',
            dataIndex: 'lpiPoints',
            align: 'center',
            render: (_,record) => Math.floor(record.lpiPoints)
        },
        {
            title: t('columns.lpiPointsChange'),
            dataIndex: 'lpiPreviousPoints',
            width: '8%',
            align: 'center',
            render: (_,record) => <PointsChange player={record} />,
            sorter: (a, b) => { 
                /* if (b.id === 593) {
                  console.warn(b.lpiPreviousPoints)
                } */
                var alpipts = (typeof(a.lpiPoints) !== 'undefined' ? a.lpiPoints : 0.0)
                var aplpipts = (typeof(a.lpiPreviousPoints) !== 'undefined' ? a.lpiPreviousPoints : 0.0)
                var blpipts = (typeof(b.lpiPoints) !== 'undefined' ? b.lpiPoints : 0.0)
                var bplpipts = (typeof(b.lpiPreviousPoints) !== 'undefined' ? b.lpiPreviousPoints : 0.0)
                if ((alpipts - aplpipts) === (blpipts - bplpipts)) {
                  return 0;
                }
                
                if ((alpipts - aplpipts) < (blpipts - bplpipts)) {
                  return 1;
                } else {
                  return -1;
                }
              },
        },
        {
          title: t('columns.tppPoints'),
          dataIndex: 'currentTppPoints',
          width: '8%',
          align: 'center',
          render: (_,record) => Math.floor(record.currentTppPoints),
          sorter: (a, b) => { 
            if (a.currentTppPoints === b.currentTppPoints) {
              return 0;
            }
            
            if (a.currentTppPoints < b.currentTppPoints) {
              return 1;
            } else {
              return -1;
            }
          },
        },
        {
            title: t('columns.topAppearances'),
            dataIndex: 'lpiTopAppearances',
            align: 'right',
            // render: (_,record) => <span>{record.tournamentHistory.length}</span>
        },
    ];

    useEffect(() => {
        fetch(api.rankings().list().href)
          .then(res => res.json())
          .then(
            (result) => {
              setIsLoaded(true);
              setItems(_.filter(result.payLoad, function(o) { return o.isActive; }));
            },
            // Note: it's important to handle errors here
            // instead of a catch() block so that we don't swallow
            // exceptions from actual bugs in components.
            (error) => {
              setIsLoaded(true);
              setError(error);
            }
          )
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
      }, [])

      const isMobile = width <= 768;
      if (error != null) {
        return (
            <>
            <h1>
                LPI Ranking
            </h1>
            <Card>
              <Result
                status="error"
                title="Ops, something went wrong!"
                subTitle="Retry later!"
              />
            </Card>
                
            </>
        );
      }
      if (isMobile) {
        return (
            <>
            <h1>
                LPI Ranking
            </h1>
            <h4 style={{ padding: '16px' }}>{t('common.tppInfo')}</h4>
            <Row justify={"center"} style={{ padding: '16px' }}>
              {
                !isLoaded &&
                <Flex gap="middle" vertical>
                  <Flex gap="middle">
                    <Spin tip="Loading" size="large">
                      <div style={{ padding: 50, background: 'rgba(0, 0, 0, 0.05)', borderRadius: 4 }} />
                    </Spin>
                  </Flex>
                </Flex>
              }
              {
                items.map(player => {
                  const ps = [
                    {
                      key: '1',
                      label: 'LPI Points',
                      children : <Space>{player.lpiPoints}</Space>
                    },
                    {
                      key: '2',
                      label: 'TPP Points',
                      children: <Space>{player.currentTppPoints}</Space>
                    }
                  ]
                  return (
                    <Col span={24}>
                      <Link to={'/players/'+player.id+'/'}>
                        <Card className={`card-ranking ${checkQualified(player)}`} style= {{ width: '100%', marginBottom: '8px' }} title={`# ${player.lpiRanking} - ${player.firstName} ${player.lastName}`}>
                          <Descriptions size="small" title="Player Stats" items={ps} column={{ xs: 2, sm: 2, md: 3, lg: 3, xl: 4, xxl: 4 }} />
                        </Card>
                      </Link>
                    </Col>
                  )
              })
              }
            </Row>
            </>
        );
      }
      return (
        <motion.div initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}} className="content-body">
        <h1>
            LPI Ranking
        </h1>
        <h4>{t('common.tppInfo')}</h4>
        <Table
            rowClassName={(record, index) => index < 8 ? 'table-row-qualified' :  '' } 
            columns={columns} 
            dataSource={items} 
            pagination={false} 
            loading={!isLoaded}
            scroll={{
              y: '90vh',
            }}
        />
            
        </motion.div>
    );
}

export default Ranking;